import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import {
    apiCountriesList,
    apiStatesList,
    apiListRoles,
    apiListUsers,
    apiListCustomers,
    apiListInspectors,
    apiListProjects,
    apiListTransformers,
    apiListTestTypes,
    apiListGlobals,
    apiListCoolingTypes,
    apiListReferenceStandards,
    apiListWindingMaterials,
    apiListEquipments,
    apiListDiagrams,
    apiListTransformerTests,
    apiListFeedbacks,
    apiListLabSurfaceAreas,
} from 'Services/UserService'

export const getCountries = createAsyncThunk('user/list/getCountries', async () => {
    const { data } = await apiCountriesList()
    return data
})

export const getStates = createAsyncThunk('user/list/getStates', async id => {
    const { data } = await apiStatesList(id)
    return data
})

export const getRoles = createAsyncThunk('user/list/getRoles', async () => {
    const { data } = await apiListRoles()
    return data
})

export const getUsers = createAsyncThunk('user/list/getUsers', async () => {
    const { data } = await apiListUsers()
    return data
})

export const getCustomers = createAsyncThunk('user/list/getCustomers', async () => {
    const { data } = await apiListCustomers()
    return data
})

export const getInspectors = createAsyncThunk('user/list/getInspectors', async () => {
    const { data } = await apiListInspectors()
    return data
})

export const getProjects = createAsyncThunk('user/list/getProjects', async () => {
    const { data } = await apiListProjects()
    return data
})

export const getTransformers = createAsyncThunk('user/list/getTransformers', async id => {
    const { data } = await apiListTransformers(id)
    return data
})

export const getTestTypes = createAsyncThunk('user/list/getTestTypes', async id => {
    const { data } = await apiListTestTypes(id)
    return data
})

export const getGlobals = createAsyncThunk('user/list/getGlobals', async () => {
    const { data } = await apiListGlobals()
    return data
})

export const getCoolingTypes = createAsyncThunk('user/list/getCoolingTypes', async () => {
    const { data } = await apiListCoolingTypes()
    return data
})

export const getReferenceStandards = createAsyncThunk('user/list/getReferenceStandards', async () => {
    const { data } = await apiListReferenceStandards()
    return data
})

export const getWindingMaterials = createAsyncThunk('user/list/getWindingMaterials', async () => {
    const { data } = await apiListWindingMaterials()
    return data
})

export const getEquipments = createAsyncThunk('user/list/getEquipments', async () => {
    const { data } = await apiListEquipments()
    return data
})

export const getDiagrams = createAsyncThunk('user/list/getDiagrams', async () => {
    const { data } = await apiListDiagrams()
    return data
})

export const getLabSurfaceAreas = createAsyncThunk('user/list/getLabSurfaceAreas', async () => {
    const { data } = await apiListLabSurfaceAreas()
    return data
})

export const getTransformerTests = createAsyncThunk('user/list/getTransformerTests', async id => {
    const { data } = await apiListTransformerTests(id)
    return data
})

export const getFeedbacks = createAsyncThunk('user/list/getFeedbacks', async () => {
    const { data } = await apiListFeedbacks()
    return data
})

export const listSlice = createSlice({
    name: 'user/list',
    initialState: {
        loading: true,
        countries: [],
        states: [],
        roles: [],
        users: [],
        customers: [],
        inspectors: [],
        projects: [],
        transformers: [],
        testTypes: [],
        globals: [],
        coolingTypes: [],
        referenceStandards: [],
        windingMaterials: [],
        equipments: [],
        diagrams: [],
        labSurfaceAreas: [],
        tests: [],
        feedbacks: [],
    },
    extraReducers: builder => {
        builder
            .addCase(getCountries.fulfilled, (state, { payload }) => {
                state.countries = payload
                state.states = []
            })
            .addCase(getCountries.rejected, state => {
                state.countries = []
                state.states = []
            })

            .addCase(getStates.fulfilled, (state, { payload }) => {
                state.states = payload
            })
            .addCase(getStates.rejected, state => {
                state.states = []
            })

            .addCase(getRoles.fulfilled, (state, { payload }) => {
                state.roles = payload
            })
            .addCase(getRoles.rejected, state => {
                state.roles = []
            })

            .addCase(getUsers.fulfilled, (state, { payload }) => {
                state.users = payload
            })
            .addCase(getUsers.rejected, state => {
                state.users = []
            })

            .addCase(getCustomers.fulfilled, (state, { payload }) => {
                state.customers = payload
            })
            .addCase(getCustomers.rejected, state => {
                state.customers = []
            })

            .addCase(getInspectors.fulfilled, (state, { payload }) => {
                state.inspectors = payload
            })
            .addCase(getInspectors.rejected, state => {
                state.inspectors = []
            })

            .addCase(getProjects.fulfilled, (state, { payload }) => {
                state.projects = payload
            })
            .addCase(getProjects.rejected, state => {
                state.projects = []
            })

            .addCase(getTransformers.fulfilled, (state, { payload }) => {
                state.transformers = payload
            })
            .addCase(getTransformers.rejected, state => {
                state.transformers = []
            })

            .addCase(getTestTypes.fulfilled, (state, { payload }) => {
                state.testTypes = payload
            })
            .addCase(getTestTypes.rejected, state => {
                state.testTypes = []
            })

            .addCase(getGlobals.pending, state => {
                state.loading = true
            })
            .addCase(getGlobals.fulfilled, (state, { payload }) => {
                state.loading = false
                state.globals = payload
            })
            .addCase(getGlobals.rejected, state => {
                state.loading = false
                state.globals = []
            })

            .addCase(getCoolingTypes.fulfilled, (state, { payload }) => {
                state.coolingTypes = payload
            })
            .addCase(getCoolingTypes.rejected, state => {
                state.coolingTypes = []
            })

            .addCase(getReferenceStandards.fulfilled, (state, { payload }) => {
                state.referenceStandards = payload
            })
            .addCase(getReferenceStandards.rejected, state => {
                state.referenceStandards = []
            })

            .addCase(getWindingMaterials.fulfilled, (state, { payload }) => {
                state.windingMaterials = payload
            })
            .addCase(getWindingMaterials.rejected, state => {
                state.windingMaterials = []
            })

            .addCase(getEquipments.fulfilled, (state, { payload }) => {
                state.equipments = payload
            })
            .addCase(getEquipments.rejected, state => {
                state.equipments = []
            })

            .addCase(getDiagrams.fulfilled, (state, { payload }) => {
                state.diagrams = payload
            })
            .addCase(getDiagrams.rejected, state => {
                state.diagrams = []
            })

            .addCase(getLabSurfaceAreas.fulfilled, (state, { payload }) => {
                state.labSurfaceAreas = payload
            })
            .addCase(getLabSurfaceAreas.rejected, state => {
                state.labSurfaceAreas = []
            })

            .addCase(getTransformerTests.fulfilled, (state, { payload }) => {
                state.tests = payload
            })
            .addCase(getTransformerTests.rejected, state => {
                state.tests = []
            })

            .addCase(getFeedbacks.fulfilled, (state, { payload }) => {
                state.feedbacks = payload
            })
            .addCase(getFeedbacks.rejected, state => {
                state.feedbacks = []
            })
    },
})

export default listSlice.reducer
